import { AuthService, type SendOtpCodeBodyDto } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

type TParams = {
  call: TCall;
  requestBody: SendOtpCodeBodyDto;
};

export const sendOtpCode = ({ call, requestBody }: TParams) => call(() => AuthService.sendOtpCode({ requestBody }));
